import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ExamPage from "./ExamPage";
import ExamLoader from "./ExamLoader";

export default function CompletedExam() {
  const { submissionId } = useParams();
  const [data, setData] = useState(null);

  /* ───────── LOAD SUBMISSION ───────── */
  useEffect(() => {
    fetch(`/api/submissions/${submissionId}`)
      .then(res => res.json())
      .then(setData)
      .catch(err => console.error(err));
  }, [submissionId]);

  if (!data) {
    return <ExamLoader message="Loading your submission..." />;
  }

  const score = Number(data.score ?? 0); // may be > 100

  return (
    // <div style={{ maxWidth: 960, margin: "0 auto", padding: 24 }}>
    <>
      {/* ───── BIG SCORE ───── */}
      <div
        style={{
          fontSize: "48px",
          fontWeight: 700,
          marginBottom: "24px",
          textAlign: "center"
        }}
      >
        {score} / 100
      </div>

      {/* ───── REVIEW MODE EXAM ───── */}
      <ExamPage
        exam={data.exam}
        initialAnswers={data.answers}
        initialFeedback={data.grading?.results}
        initialMode="review"
        readOnly
      />
      </>
    // </div>
  );
}
